<template>
  <section
    :id="sectionIdName"
    class="lottie-micro-ani-handler no-flicker"
    :style="{
      top: microAnimation.animationPosition.top + '%',
      left: microAnimation.animationPosition.left + '%',
      width: microAnimation.width + '%',
      height: microAnimation.height + '%'
    }"
  >
    <lottie
      ref="lottie"
      class="lottie-micro-ani-handler__lottie-wrapper"
      v-on:animCreated="handleAnimation"
    ></lottie>
    <!-- <button @click="pause">THIS IS A PAUSE BUTTON</button> -->
  </section>
</template>

<script>
import Lottie from "@/assets/vue-lottie";
import axios from "axios";
export default {
  name: "lottie-micro-ani-handler",
  components: {
    lottie: Lottie
  },
  props: ["microAnimation", "sectionIdName"],
  methods: {
    fetchData(string, json) {
      return new Promise((resolve, reject) => {
        axios.get(string + json).then(res => {
          resolve(res.data);
        });
      });
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    play() {
      this.anim.goToAndPlay(1, true);
    },
    pause() {
      // pauses animation
      this.anim.pause();
    }
  },
  mounted() {
    this.fetchData(
      "/json-animations/micro/",
      this.microAnimation.animation
    ).then(res => {
      this.defaultOptions = {
        renderer: "svg",
        animationData: res,
        autoplay: false,
        loop: false,
        rendererSettings: {
          scaleMode: "noScale",
          progressiveLoad: true,
          hideOnTransparent: true,
          className: `lottie-section`
        }
      };
      this.$refs.lottie.load(this.defaultOptions);
      this.play();
    });
  }
};
</script>

<style scoped lang="scss">
.lottie-micro-ani-handler {
  position: absolute;

  &__lottie-wrapper {
    position: relative;
    width: 100%;
    zoom: 100%;
  }
}

button {
  position: absolute;
  top: 30%;
  left: 100%;
}
</style>
